module.exports = __webpack_public_path__ + "static/healtcare-blog-img-2-1d3b64c7f07f18b49571445d15c97210.jpg";